(function() {
  const widget = document.getElementById('yip-wa-widget');
  if (!widget) return;

  const link = document.getElementById('yip-wa-link');
  const btnClose = document.getElementById('yip-wa-close');

  const normalizeTR = (raw) => {
    let p = String(raw || '').replace(/\D+/g, '');
    if (p.startsWith('00')) p = p.slice(2);
    if (p.startsWith('0') && p.length === 11) p = p.slice(1);
    if (!p.startsWith('90') && p.length === 10) p = '90' + p;
    return p;
  };

  const phone = normalizeTR(widget.getAttribute('data-phone'));
  const waURL = `https://wa.me/${phone}`;
  link.href = waURL;

  const open = () => widget.classList.add('yip-wa-expanded');
  const close = () => widget.classList.remove('yip-wa-expanded');

  widget.addEventListener('click', (e) => {
    const isDesktop = window.matchMedia('(min-width: 1200px)').matches;
    if (!isDesktop && !widget.classList.contains('yip-wa-expanded')) {
      open();
    }
  });

  btnClose.addEventListener('click', (e) => {
    e.stopPropagation();
    close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && widget.classList.contains('yip-wa-expanded')) {
      close();
    }
  });

  document.addEventListener('click', (e) => {
      if (!widget.contains(e.target) && widget.classList.contains('yip-wa-expanded')) {
          close();
      }
  });

  let scrollTimeout;
  let ticking = false;

  const handleScroll = () => {
    const isDesktop = window.matchMedia('(min-width: 1200px)').matches;
    if (isDesktop) return;

    widget.classList.add('yip-wa-scrolling');
    
    clearTimeout(scrollTimeout);

    scrollTimeout = setTimeout(() => {
      widget.classList.remove('yip-wa-scrolling');
    }, 300); 
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
})();